var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgPpt = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 21,
    viewBox: "0 0 37 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5751 13.5V11.2195L12.5501 11.2217C12.9988 11.2363 13.4445 11.1436 13.85 10.9515C14.1875 10.7882 14.4687 10.5286 14.6581 10.2057C14.8424 9.87553 14.9358 9.50265 14.929 9.12485C14.9428 8.83828 14.8957 8.55207 14.7907 8.28495C14.6858 8.01783 14.5254 7.77587 14.3201 7.57498C13.9157 7.19165 13.3264 7 12.5522 7H10V13.5H11.5751ZM12.3767 8.2602C13.0094 8.2602 13.3257 8.54842 13.3257 9.12485C13.3257 9.68255 13.0094 9.95854 12.3767 9.95278H11.5751V8.2602H12.3767Z",
    fill: "#FF3E4C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.2797 11.2195V13.5H15.7025V7H18.2547C19.0303 7 19.6204 7.19165 20.0248 7.57498C20.2301 7.77587 20.3905 8.01783 20.4954 8.28495C20.6003 8.55207 20.6474 8.83828 20.6336 9.12485C20.6407 9.50295 20.5465 9.87609 20.3606 10.2057C20.1726 10.529 19.8919 10.7887 19.5546 10.9515C19.1491 11.1436 18.7034 11.2363 18.2547 11.2217L17.2797 11.2195ZM19.0303 9.12485C19.0303 8.54842 18.714 8.2602 18.0814 8.2602H17.2797V9.95278H18.0814C18.714 9.95854 19.0303 9.68255 19.0303 9.12485Z",
    fill: "#FF3E4C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.089 7V8.2516H24.3189V13.5H22.7351V8.2516H20.9824V7H26.089Z",
    fill: "#FF3E4C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.16833 2C1.87589 2 0 3.87174 0 6.20259V14.7974C0 17.1283 1.87589 19 4.16833 19H32.8317C35.1241 19 37 17.1283 37 14.7974V6.20259C37 3.87174 35.1241 2 32.8317 2H4.16833ZM0.973684 6.20259C0.973684 4.44367 2.39431 3 4.16833 3H32.8317C34.6057 3 36.0263 4.44368 36.0263 6.20259V14.7974C36.0263 16.5563 34.6057 18 32.8317 18H4.16833C2.39431 18 0.973684 16.5563 0.973684 14.7974V6.20259Z",
    fill: "#FF3E4C"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPpt);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ppt.97620cd2b36d5b96284ad46b8641e8e7.svg";